/**
 * Generated bundle index. Do not edit.
 */

export * from './public_api';

export {CanvasComponent as ɵc} from './core/canvas.component';
export {ClipPathComponent as ɵb} from './core/clip-path.component';
export {SvgComponent as ɵa} from './core/svg.component';